// @ts-check

import { useHistory, useLocation } from "react-router-dom"

/**
 * @param {string} key
 */
function useSearchQuery(key) {
  const location = useLocation()
  const history = useHistory()

  const searchParams = new URLSearchParams(location.search)

  /** @param {string | null} value */
  function setSearchQuery(value) {
    const newSearchParams = new URLSearchParams(location.search)
    if (value == null) newSearchParams.delete(key)
    else newSearchParams.set(key, value)

    history.replace({
      ...location,
      search: newSearchParams.toString(),
    })
  }

  const searchQuery = searchParams.get(key)

  return /**@type{const}*/([
    searchQuery,
    setSearchQuery
  ])
}

export default useSearchQuery